<template>
  <div class="person-info-container">
    <div class="header">
      <span style="font-size: 20px;">个人主页</span>
      <div>
        <el-button type="primary" size="big" @click="editable ? save() : update()">
          {{ editable ? '保存信息 ' : '修改信息' }}
        </el-button>
        <el-button type="danger" size="big" @click="logout" style="margin: 15px;">退出登录</el-button>
      </div>
    </div>

    <div class="title-wrapper">
      <el-upload class="avatar-uploader" :action="uploadImag" :show-file-list="false" :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload" :with-credentials="true">

        <el-image v-if="comimageUrl" :src="comimageUrl" class="avatar"></el-image>

        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>

    <el-form :model="editable ? newform : form" style=" background-color: #ffe4e1;">
      <el-form-item align="center">
          <span style="font-size: 20px;">
            个人信息
          </span>
      </el-form-item>

      <el-form-item label="姓名:" label-width="120px">
        {{ form.nickName }}
      </el-form-item>
      <el-form-item label="手机号:"  label-width="120px">
        <template v-if="!editable">{{ form.phonenumber }}</template>
        <el-input v-else v-model="newform.phonenumber" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="身份证号:" label-width="120px">
       {{ form.card  }}
      </el-form-item>
      <el-form-item label="身份:"  label-width="120px">
        {{ form.remark }} <!-- 身份信息不可修改 -->
      </el-form-item>
      <el-form-item label="用户名:" label-width="120px">

        <template v-if="!editable">{{ form.userName }}</template>
        <el-input v-else v-model="newform.userName" placeholder="请输入用户名"></el-input>

      </el-form-item>
      <el-form-item label="旧密码:" v-if="editable"  label-width="120px">
        <el-input v-model="password.oldPassword" placeholder="请输入旧密码"></el-input>
       
      </el-form-item>

      <el-form-item label="新密码:" v-if="editable"  label-width="120px">
         <el-input v-model="password.rawPassword" placeholder="请输入新密码"></el-input>
      </el-form-item>

      <el-form-item label="确认新密码:" v-if="editable"  label-width="120px">
         <el-input v-model="password.rawPassword1" placeholder="请输入新密码"></el-input>
      </el-form-item>

      <el-form-item label="家庭地址:" v-if="role !== 'admin'" label-width="120px">
        <template v-if="!editable">
          <span v-if="form.address">{{ form.address }}</span>
          <span v-else style="color:darkgray;">暂无数据</span>
        </template>
        <el-input v-else v-model="newform.address" placeholder="请输入家庭地址"></el-input>
      </el-form-item>

      <el-form-item align="center">
          <span style="font-size: 20px;">
            学校信息
          </span>
      </el-form-item>
      <el-form-item label="学校名称:" label-width="120px">
        {{ form.deptName  }}
      </el-form-item>
      <el-form-item label="专业:" label-width="120px">
        {{ form.majorName }}
      </el-form-item>
      <el-form-item label="班级:" label-width="120px">
        {{ form.className }}
      </el-form-item>
      <el-form-item label="学制:" label-width="120px">
        {{ form.majorYear }}
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updateUserProfile, uploadAvatar, getUserProfile, updateUserPwd } from '@/api/system/user';
import { getInfo } from '@/api/login';
import { delToseck } from '@/utils/toseck';
import { Loading } from 'element-ui';
export default {
  created() {
    this.setInfo();
    this.setprofile()
    this.role = sessionStorage.getItem('identity')
  },
  computed: {
    comimageUrl() {
      const url = this.getimageUrl(this.form.avatar)
      return url;
    },
  },
  data() {
    return {
      editable: false,
      form: {},
      newform: {
        address: '',
        email: '',
        name: '',
        phonenumber: '',
        card: '',
      },
      role: '',
      password:{
        oldPassword: '',
        rawPassword: '',
        rawPassword1: ''
      },
      uploadImag: process.env.VUE_APP_BASE_API + "/common/upload",
      imageUrl: null,
    }
  },
  methods: {
    getimageUrl(url) {
      if (!url) {
        return;
      }
      return  url;
    },

    handleAvatarSuccess(res, file) {
      let formdata = new FormData();
      formdata.append("avatarfile", file.raw);
      uploadAvatar(formdata).then(r => {
        if (r.code === 200) {
          Loading.service().close()
          this.$message.success("上传成功")
          this.imageUrl = URL.createObjectURL(file.raw);
          this.setprofile()

          // window.location.reload()
        } else {
          console.log(r)
          Loading.service().close()
          this.$message.error("上传失败")
        }
      })
    },

    beforeAvatarUpload(file) {
      Loading.service({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
      })
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      return (isJPG || isPNG) && isLt2M;
    },
    logout() {
      delToseck()
      this.$router.push('/login');
      window.location.reload()
    },
    
    setprofile() {
      getUserProfile().then(r => {
        if (r.code === 200) {
          console.log("我",r);
           this.form = r.data;
          this.form.address = r.user.address
          this.form.card = r.user.card
          this.form.majorName = r.user.majorName
          this.form.majorYear = r.major.majorYear
          this.form.className = r.user.className
          this.form.deptName=r.dept.deptName
        
        }
      }).catch((r) => {
        console.log(r)

      })
    },
    setInfo() {
       
      getInfo().then(r => {
        this.imageUrl = r.user.avatar
      }).catch((r) => {
        this.$message.error(r.msg)
      })
    },

    update() {
      this.editable = !this.editable
      this.newform = { ...this.form }
      this.password.rawPassword = ''
    },

    save() {
      const bool = this.editable
      if (bool) {

      // 添加手机号长度验证
    if (this.newform.phonenumber && this.newform.phonenumber.length > 11) {
      this.$message.error('手机号不能超过11位');
      return;
    }
    const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.newform.phonenumber)) {
        this.$message.error('请输入有效的手机号码');
        return;
      }
    
        if (this.password.rawPassword) {

          if (this.password.rawPassword !== this.password.rawPassword1) {
            this.$message.error("两次输入密码不一致")
            return
          }

          if(this.password.rawPassword.length<5) {
            this.$message.error("新密码长度不能小于5位")
            return
          }
          updateUserPwd(this.password.oldPassword,this.password.rawPassword).then((r) => {
            if (r.code === 200) {   
           console.log("修改密码成功");
           this.$router.push('/login');
           window.location.reload();
           
          }

          }).catch((r) => {
            this.$message.error(r.msg+"修改密码失败")
          })
        }
        updateUserProfile(this.newform).then(r => {
          if (r.code === 200) {
            this.$message.success("修改成功")
            this.setprofile()
            this.editable = !bool
          } else {
            console.log(r)
            this.$message.error("修改失败")
            this.editable = !bool
          }
        }).catch((r) => {
          this.$message.error(r.msg)
        })
      }
    }
  }
}
</script>
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9f2f4;
}

.header .el-button {
  margin-left: 20px;
}

.person-info-container {
  height: 100%;
  padding: 20px;
  background-color: #f9f2f4;
  /* 淡粉色背景，与 IndexView 主体背景一致 */
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(232, 62, 140, 0.3);
  /* 玫红色阴影，增强立体感 */
  transition: all 0.3s ease;
  /* 添加过渡效果 */
}

.person-info-container:hover {
  box-shadow: 0 0 15px rgba(232, 62, 140, 0.5);
  /* 鼠标悬停时加深阴影 */
}

.avatar-uploader .el-upload-list {
  display: none;
}

.el-form-item {
  margin-bottom: 0;
  border: 1px solid #ccc;
}

.el-form .el-form-item {
  background-color: #ffffff;
}

.avatar {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  overflow: hidden;
  transition: border-color 0.3s ease;
}

.avatar:hover {
  border-color: #d6336c;
  /* 鼠标悬停时边框颜色加深 */
}

.avatar-uploader {
  width: 66px;
  height: 66px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  overflow: hidden;
  background-color: #e83e8c;
  /* 玫红色背景 */
  transition: background-color 0.3s ease;
}

.avatar-uploader:hover {
  background-color: #d6336c;
  /* 鼠标悬停时背景颜色加深 */
}

.avatar-uploader-icon {
  color: white;
  /* 图标颜色为白色 */
}

.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  background-color: #d7d1d1c0;
  padding: 15px 20px;
  border-radius: 8px 8px 0 0;
}

.el-descriptions {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(232, 62, 140, 0.3);
  /* 玫红色阴影 */
  transition: all 0.3s ease;
}

.el-descriptions:hover {
  box-shadow: 0 0 15px rgba(232, 62, 140, 0.5);
  /* 鼠标悬停时加深阴影 */
}

.el-descriptions__title {
  padding: 15px 20px;
  background-color: #f0f0f0;
}

.el-descriptions__item {
  padding: 12px 20px;
}

.el-button {
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.el-button.primary {
  background-color: #e83e8c;
  /* 玫红色背景 */
  border-color: #e83e8c;
}

.el-button.primary:hover {
  background-color: #d6336c;
  /* 鼠标悬停时背景颜色加深 */
  border-color: #d6336c;
}

.el-button.danger {
  background-color: #dc3545;
  border-color: #dc3545;
}

.el-button.danger:hover {
  background-color: #c82333;
  border-color: #c82333;
}
</style>